var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
//import nem from 'nem-sdk';
//import localForage from 'localforage';
//import nemWrapper from './nemWrapper';
import axios from 'axios';
import helper from './helper';
var getAccountList = /** @class */ (function () {
    function getAccountList() {
        var _this = this;
        /*account data */
        this.address = '';
        this.accountList = [];
        this.errorMessage = '';
        this.company = "";
        this.helper = new helper();
        this.loadAccountList("Account-List").then(function (result) {
            _this.vars(result);
        });
    }
    getAccountList.prototype.vars = function (result) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.company = result[0];
                this.accountList = result[1];
                return [2 /*return*/];
            });
        });
    };
    getAccountList.prototype.loadAccountList = function (key) {
        return __awaiter(this, void 0, void 0, function () {
            var data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        console.log("in loadAccountlist");
                        return [4 /*yield*/, this.getAccountListfromAPI()];
                    case 1:
                        data = _a.sent();
                        this.helper.save('Account-List', data);
                        //}
                        return [2 /*return*/, data];
                }
            });
        });
    };
    getAccountList.prototype.getAccountListfromAPI = function () {
        return __awaiter(this, void 0, void 0, function () {
            var result, tmp, url, headers, access_token, uid, client;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        result = [];
                        console.log("in loadAccountlistfromapi");
                        return [4 /*yield*/, this.helper.load('SmartUQ-Wallet')];
                    case 1:
                        tmp = _a.sent();
                        if (!(tmp && tmp.address)) return [3 /*break*/, 4];
                        this.address = tmp.address;
                        console.log(this.address);
                        url = this.helper.path + "auth_users/belong_users/" + this.address;
                        return [4 /*yield*/, this.helper.loadHeaders()];
                    case 2:
                        headers = _a.sent();
                        access_token = headers["access-token"];
                        uid = headers["uid"];
                        client = headers["client"];
                        return [4 /*yield*/, axios.get(url, {
                                headers: { "Content-Type": "application/json",
                                    "access-token": access_token,
                                    "uid": uid,
                                    "client": client },
                                data: {}
                            })
                                // thenで成功した場合の処理をかける
                                .then(function (response) {
                                console.log('status:', response.status); // 200
                                console.log(response.data);
                                result = response.data.data;
                                // catchでエラー時の挙動を定義する
                            }).catch(function (error) {
                                if (error.response && error.response.status == "401") {
                                    console.log("please login");
                                    _this.helper.pleaseLogin();
                                }
                            })];
                    case 3:
                        _a.sent();
                        return [2 /*return*/, result];
                    case 4:
                        this.helper.pleaseLogin();
                        return [2 /*return*/];
                }
            });
        });
    };
    return getAccountList;
}());
export default getAccountList;



//////////////////
// WEBPACK FOOTER
// ./src/ts/getAccountList.ts
// module id = 267
// module chunks = 1